export const SR_GENERATE_OFFICE = 'SR_GENERATE';
export const SR_PROCESS_OFFICE = 'SR_PROCESS';
